import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClickButton"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { actions } from '../../constants/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const InvoiceVoidButton = _ref => {
  let {
      onClickButton
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const tooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.pending.void"
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !buttonProps.disabled,
    title: tooltipTitle,
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      "data-test-id": "void-btn",
      use: "tertiary-light",
      responsive: false,
      size: "extra-small",
      onClick: () => onClickButton(actions.VOID)
    }, buttonProps, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.buttons.void"
      })
    }))
  }, "void-btn");
};
export default InvoiceVoidButton;